import React, {useEffect} from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import qs from 'querystring'; 
import { useTranslation } from 'react-i18next';
import {includes} from 'lodash';
import Navbar from '../Navbar';
import { currentLang } from '../../../utils/functions';
import smoothscroll from 'smoothscroll-polyfill';

const Header = () => {
  const { pathname } = useLocation();
  const {t} = useTranslation();
  
  smoothscroll.polyfill();
  
  useEffect(() => {
    //https://www.koopeenkoe.nl/shop/ajaxflow/cb_add_coupon
    var url = window.location.href;
    var http_config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    if(url.indexOf('?invite=') > 0){
        var inviteId = url.split('?invite=')[1].split('&')[0];
        var postdata = {
          action: 'cb_add_coupon',
          couponcode: inviteId,
          shortinit: 'fast'
        }
        axios.post('/'+currentLang()+'/shop/ajaxflow/cb_add_coupon', qs.stringify(postdata), http_config).then(function(response){ console.log(response.data); });   
    }
    
  }, [])

  useEffect(() => {
    document.documentElement.setAttribute('lang', currentLang());
    if(!includes(pathname, t("menu.animal")) && !includes(pathname, t("menu.faq")) && !includes(pathname, t("menu.products"))){
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return (
    <header className={"header__top" + (" " + currentLang())}>
        <div className="container">
          <Navbar /> {/* Nav + hamburger */}
        </div>
    </header>
  )
}

export default Header
